const selectAvalBuroForm = state => state.avalBuroForm;

export const selectAvalQuoteInformation = state =>
  selectAvalBuroForm(state).quoteInformation;

export const selectAvalTokenValidationStatus = state =>
  selectAvalBuroForm(state).tokenValidationStatus;

export const selectAvalBuroFormId = state => selectAvalBuroForm(state).formId;

export const selectAvalBuroFormResult = state =>
  selectAvalBuroForm(state).formResult;
